import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ({ clientName, isCavendish = false }) {
	const { t } = useTranslation('survey');

	let dataCompanies = 'companies';

	if (
		clientName === 'Cavendish' ||
		clientName === 'Cavendish Consulting' ||
		clientName === 'Cavendish Consulting Ltd' ||
		clientName === null
	) {
		isCavendish = true;
		dataCompanies = '';
	}

	return (
		<div className='data_usage'>
			<h2>{t('survey.data.title')}</h2>
			<p>
				{ isCavendish ? t('survey.data.cavendish-runs') : <span dangerouslySetInnerHTML={{ __html: t('survey.data.cavendish-acts', { clientName: '<b>' + clientName + '</b>' }) }} /> }
			</p>
			<p>{t('survey.data.confirm-data')}</p>
			<p>{t('survey.data.share-data', { dataCompanies: dataCompanies })}</p>
			<p>{t('survey.data.not-used-consent')}</p>
			<p>{t('survey.data.will-use-data-to')}</p>
			<ul>
				<li>{t('survey.data.send-updates')}</li>
				<li>{t('survey.data.develop-overview')}</li>
			</ul>
			<p>{t('survey.data.may-contact')}</p>
		</div>
	);
}
